import { Tooltip } from 'chart.js';

/**
 * Defines a custom tooltip positioner that places the tooltip diagonally
 * depending on whether the pointer is in the left or right half of the chart.
 */
export const registerSmartTooltipPositioner = () => {
    Tooltip.positioners.smart = function (items, eventPosition) {
        if (!items.length) return false;

        const chart = items[0].element.$context.chart;
        const { chartArea } = chart;
        const { x, y } = eventPosition;

        // Compute the midpoint of the chart horizontally and vertically
        const midX = (chartArea.left + chartArea.right) / 2;
        const midY = (chartArea.top + chartArea.bottom) / 2;
        const isLeftHalf = x < midX;
        const isTopHalf = y < midY;

        // Set base offsets
        const horizontalOffset = 20;
        const verticalOffset = 40;

        // Tooltip floats diagonally away from cursor
        const offsetX = isLeftHalf ? horizontalOffset : -horizontalOffset;
        const offsetY = isTopHalf ? verticalOffset : -verticalOffset;

        return {
            x: x + offsetX,
            y: y + offsetY,
        };
    };
};